/**
 * Minimal CSV helpers — RFC 4180-ish.
 * - Escapes any field containing ",", '"', "\n" or "\r" by quoting + doubling quotes.
 * - Always emits CRLF line endings (Excel-friendly).
 * - Neutralises formula-like text cells (CSV injection).
 * - Prepends a UTF-8 BOM so Excel/Numbers detect Unicode correctly.
 */

/**
 * Spreadsheet formula-injection guard: a string cell starting with
 * = + - @ TAB or CR is prefixed with a single quote so Excel/Sheets treat it
 * as text. Real numbers (typeof number) are left alone so negatives still
 * export as numbers.
 */
const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

export function csvEscape(value: unknown): string {
  if (value === null || value === undefined) return "";
  let s = String(value);
  if (typeof value !== "number" && FORMULA_TRIGGER.test(s)) s = `'${s}`;
  if (/[",\r\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

export function buildCsv(headers: string[], rows: (string | number | null | undefined)[][]): string {
  const head = headers.map(csvEscape).join(",");
  const body = rows.map((r) => r.map(csvEscape).join(",")).join("\r\n");
  return `﻿${head}\r\n${body}\r\n`;
}

export function downloadCsv(filename: string, content: string): void {
  const blob = new Blob([content], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Defer revoking so older Safari finishes the download.
  setTimeout(() => URL.revokeObjectURL(url), 1500);
}
